require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-bmw-mini-group.json") })
        }
      }, "path---authors-bmw-mini-group");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-bmw-mini-group!./.cache/json/authors-bmw-mini-group.json
// module id = 1259
// module chunks = 231608221292675